import { Hourglass } from 'lucide-react';
import { formatGapDuration } from './format';
import type { SilenceGap } from './audio-sync';

/**
 * The marker drawn between two lines separated by a conspicuous wait.
 *
 * "UP TO", NOT "OF". `intervalMs` runs from the previous line's end to this
 * line's end, so its tail is the line actually being spoken — the silence is
 * strictly less. Nothing in `interaction_messages` records how long an
 * utterance took, so the exact silence is not available at any price, and the
 * upper bound is both honest and the number that made the dead air on int
 * `c1edd217` obvious. Stating it as a flat "13.5s of silence" would be the same
 * class of mistake as the gapless gutter it replaces: confidently wrong, with
 * nothing on screen to tell the reader which they are looking at.
 *
 * Deliberately a full-width rule rather than a bubble: it is not a turn, and
 * putting it in the conversation's left/right rhythm would read as one.
 */
export function SilenceGapRow({ gap }: { gap: SilenceGap }): React.ReactElement {
  return (
    <div
      data-silence-gap="true"
      className="flex items-center gap-2 py-0.5 text-[10px] text-muted-foreground"
    >
      <span className="h-px flex-1 bg-border" />
      <span className="flex items-center gap-1 whitespace-nowrap">
        <Hourglass className="h-3 w-3" />
        {`up to ${formatGapDuration(gap.intervalMs)} of silence`}
      </span>
      <span className="h-px flex-1 bg-border" />
    </div>
  );
}
